import * as React from "react";
import {BrowseDocumentsContext} from "./components/BrowseDmsDocuments";
import {Dropdown, DropdownMenuItemType, IDropdownOption, Icon} from "office-ui-fabric-react";
import {DmsCaseInfo, DmsStorageType, FilingLocation, FilterOption, PaginatedFilingLocations} from "../models";
import {LocationItemsFiltersStyles} from "./LocationItemFiltersStyles";

export interface LocationItemsFiltersProps {
    darkMode: boolean;
    caseInfo: DmsCaseInfo;
    folderSearch: boolean;
    teamsId: string;
    tenantId: string;
    userId: string;
    channelId: string;
    searchPhrase: string;
    onFilteredDataChanged: (documents: PaginatedFilingLocations) => void;
}

export default class LocationItemsFilters extends React.Component<LocationItemsFiltersProps> {
    context!: React.ContextType<typeof BrowseDocumentsContext>;

    constructor(props: LocationItemsFiltersProps, context: React.ContextType<typeof BrowseDocumentsContext>) {
        super(props, context);
    }

    getItemTypeOptions() {
        if (this.props.caseInfo.StorageType === DmsStorageType.SharePoint) {
            if (this.context.filterOptions != null && this.context.filterOptions.length > 0) {
                const filterOptions: IDropdownOption[] = this.context.filterOptions.map((filterOption) => {
                    return {key: filterOption.DisplayName, text: filterOption.DisplayName};
                });
                filterOptions.push({
                    key: "ClearAll",
                    text: "Deselect All",
                    data: {icon: "Clear"},                    
                    itemType: DropdownMenuItemType.Header,
                    disabled: false,                                        
                });
                return filterOptions;
            } else {
                return [{
                    key: "Empty", 
                    text: "No items", 
                    disabled: true, 
                    itemType: DropdownMenuItemType.Header
                }];
            }
        }
    }

    setItemTypeFilter(val: IDropdownOption) {
         let selectedOptions: FilterOption[];

        if (val.key === "ClearAll") {
            selectedOptions = [];
        } else {
            const alreadySelected =
                this.context.selectedFilters &&
                this.context.selectedFilters.some((filter) => filter.DisplayName === val.key.toString());

            if (alreadySelected && val.selected === true) {
                return;
            }

            const filterOption = this.context.filterOptions.find(
                (filterOption: FilterOption) => filterOption.DisplayName === val.key.toString()
            );

            if (val.selected === true) {
                selectedOptions = this.context.selectedFilters
                    ? this.context.selectedFilters.concat(filterOption)
                    : [filterOption];
            } else {
                selectedOptions = this.context.selectedFilters.filter(
                    (filter) => filter.DisplayName !== filterOption.DisplayName
                );
            }
        }

        this.context.setParentState({selectedFilters: selectedOptions}, () => {
            if(this.props.searchPhrase)
            {
                //If the filter selecection is changed during the search, runSearch() will be called so we do not the results to be passed and set in the state
                this.props.onFilteredDataChanged(null);
            }
            else
            {
                this.context.filterDocuments({
                    TeamsId: this.props.teamsId,
                    TenantId: this.props.tenantId,
                    UserId: this.props.userId,
                    ChannelId: this.props.channelId,
                    FolderSearch: this.props.folderSearch,
                    BrowsingDms: false,
                    FilterParameters: selectedOptions,
                    handleResult: (_results: FilingLocation[], _loadedAllPages: boolean) => {
                        const documents = this.context.getDocumentsByPath(
                            this.context.getCacheKey(this.props.folderSearch, false)
                        );
    
                        this.props.onFilteredDataChanged(documents);
                    },
                    handleError: (_) => {
                        this.props.onFilteredDataChanged({Page: [] as FilingLocation[], PagingToken: null, Errors: null});
                    },
                });
            }
        });
    }

    optionClicked = (option: IDropdownOption) => () => {
        if (option.key === "ClearAll" && this.context.selectedFilters && this.context.selectedFilters.length > 0) {
            this.setItemTypeFilter(option);
        }
    };

    onRenderOption = (option: IDropdownOption): JSX.Element => {
        return (
            <div onClick={this.optionClicked(option)}>
                {option.data && option.data.icon && (
                    <Icon
                        style={{fontSize: "12pt", marginRight: "5px"}}
                        iconName={option.data.icon}
                        aria-hidden="true"
                        title={option.data.icon}
                    />
                )}
                <span>{option.text}</span>
            </div>
        );
    };

    onRenderTitle = (options: IDropdownOption[]): JSX.Element => {
        return (
            <div>
                <span>{options.length > 0 ? `Type (${options.length})` : "Type"}</span>
            </div>
        );
    };

    onRenderItem = (option: IDropdownOption): JSX.Element => {
        return (
            <div>
                {option.data && option.data.icon === "Clear" && (
                    <Icon
                        style={{fontSize: "12pt", marginRight: "5px"}}
                        iconName={option.data.icon}
                        aria-hidden="true"
                        title={option.data.icon}
                    />
                )}
                <span>{option.text}</span>
            </div>
        );
    };

    public render() {
        return (
            <div style={{width: "150px"}}>
                <Dropdown
                    className={(this.props.darkMode ? "darkMode" : "lightMode") + " transparentDropdown"}
                    styles={this.props.darkMode ? LocationItemsFiltersStyles.getDarkModeDropdownStyle() : LocationItemsFiltersStyles.getDropdownStyle()}
                    selectedKeys={
                        this.context.selectedFilters && this.context.selectedFilters.map((filter) => filter.DisplayName)
                    }
                    onChange={(_, val) => this.setItemTypeFilter(val)}
                    options={this.getItemTypeOptions()}
                    multiSelect={true}
                    placeholder="Type"
                    onRenderOption={this.onRenderOption}
                    onRenderTitle={this.onRenderTitle}
                />
            </div>
        );
    }
}

LocationItemsFilters.contextType = BrowseDocumentsContext;
